import {colors, Modal, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import {Payment} from '../../../graphql/payments.datatypes';
import PaymentEdit from './PaymentEdit';
import {checkRole as checkMyRole} from '../../../components/Can/Can';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '90%',
    overflowY: 'auto',
    maxWidth: '95%'
  },
  container: {
    marginTop: theme.spacing(3)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  deleteButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  },
  submitButton: {
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  }
}));

const PaymentEditModal = (props: {
    className?: string,
    onClose: () => void,
    open: boolean,
    payment: Payment,
    setSelectedPayment: (payment: Payment | null) => void,
    billingPartyId?: number,
    isAdmin: boolean,
    canEdit: boolean,
}) => {
    const {open, onClose, payment, setSelectedPayment, billingPartyId, isAdmin} = props;
    const classes = useStyles();
    const isSuperAdmin = checkMyRole('super-admin');
    const isNewPayment = payment.id === -1;
    const canEdit = isSuperAdmin || (isNewPayment && isAdmin);

    if (!open) {
        return null;
    }

    return (
        <Modal onClose={onClose} open={open}>
            <React.Fragment>
                <PaymentEdit className={clsx(classes.root)} payment={payment} setSelectedPayment={setSelectedPayment}
                             billingPartyId={billingPartyId} isAdmin={isAdmin} canEdit={canEdit}/>
            </React.Fragment>
        </Modal>
    );
};

export default PaymentEditModal;
